export default {
  path: 'rank',
  name: 'rank',
  component: () => import('@/views/rank/index.vue'),
  meta: {
    locale: '数据查询',
    requiresAuth: true,
    icon: 'icon-bar-chart',
  },
  children: [
    {
      path: 'rank-list',
      name: 'rankList',
      component: () => import('@/views/rank/list/index.vue'),
      meta: {
        locale: '榜单查询',
        requiresAuth: true,
        roles: ['super', 'admin', 'service', 'special_service', 'treasurer'],
      },
    },
    {
      path: 'red-envelope',
      name: 'redEnvelope',
      component: () => import('@/views/rank/red-envelope/index.vue'),
      meta: {
        locale: '红包记录',
        requiresAuth: true,
        roles: ['super', 'admin', 'treasurer'],
      },
    },
    {
      path: 'page-stats',
      name: 'pageStats',
      component: () => import('@/views/rank/page-stats/index.vue'),
      meta: {
        locale: '页面访问统计',
        requiresAuth: true,
        roles: ['super', 'admin'],
      },
    },
  ],
};
